import getHeadConfig from './getHeadConfig';

export default (state) => {
    const { business } = getHeadConfig(state);

    return {
        business,
        deviceType: state.deviceType,
    };
};
